import { CIcon } from '~/icons/types'

export const ciSkateboard: CIcon = {
  width: 24,
  height: 24,
  paths: [
    {
      d:
        'M17.473 13.529a2.01 2.01 0 1 0 2.01 2.01 2.013 2.013 0 0 0-2.01-2.01Zm0 3.02a1.01 1.01 0 1 1 1.01-1.01 1.011 1.011 0 0 1-1.01 1.01Zm-10.579-3.02a2.01 2.01 0 1 0 2.01 2.01 2.013 2.013 0 0 0-2.01-2.01Zm0 3.02a1.01 1.01 0 1 1 1.01-1.01 1.012 1.012 0 0 1-1.01 1.01Zm15.08-4.412a.503.503 0 0 0-.593-.386l-2.694.568H5.767l-2.511-1.582a.5.5 0 0 0-.533.845l2.633 1.66a.497.497 0 0 0 .266.077H18.74a.52.52 0 0 0 .103-.01l2.745-.579a.5.5 0 0 0 .387-.593Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'skateboard',
  type: 'thin'
}
